import { render } from "./HearingTestsAdminister.vue?vue&type=template&id=7dcf7f72&scoped=true"
const script = {}

import "./HearingTestsAdminister.vue?vue&type=style&index=0&id=7dcf7f72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcf7f72"]])

export default __exports__